import { useRecoilValue } from "recoil";
import { localizationAtom } from "recoil/localizationAtom";

export default function useGetUrls() {
  const locale = useRecoilValue(localizationAtom);

  const companyInfoUrl = locale.includes("ko")
    ? "https://orwellhealth.notion.site/51d3c13a5998467489e4f2b8979b629e"
    : "https://orwellhealth.notion.site/Distancing-Business-Information-30b14f0821ab4d4192f01441e0022f1c";
  const privacyPolicyUrl = locale.includes("ko")
    ? "https://distancing.im/privacy-policy"
    : "https://distancing.im/privacy-policy";
  const servicePolicyUrl = locale.includes("ko")
    ? "https://distancing.im/terms-of-service"
    : "https://distancing.im/terms-of-service";
  return {
    companyInfoUrl,
    privacyPolicyUrl,
    servicePolicyUrl,
  };
}
